// @ts-nocheck
import '@material/web/divider/divider.js';
import React from 'react';

interface DividerProps {
  height?: string;
}

export const Divider: React.FC<DividerProps> = ({ height }) => {
  const dividerStyle = height ? { height } : {};

  return <md-divider style={dividerStyle}></md-divider>;
};
